import withProps from "recompose/withProps";

export default withProps(({ sx })=>({
	sx: { ...sx,
		minHeight: 'calc(100%)'
	}
}));